import styled, { css } from "styled-components";
import { focusWell } from "../../focusWell";
import { inputHighlighting } from "../../../utils/helpers/inputHighlighting";

export const StyledInputContainer = styled.div(({ theme }) => css`
  ${focusWell({hollow: true})}
  display: flex;
  align-items: stretch;
  justify-content: center;
  
  &, & input {
    font-size: 20px;
    font-weight: ${theme.fonts.headingWeight};
  }

  ${inputHighlighting()}
`);

export const StyledInput = styled.input(({ theme }) => css`
  flex: 1;
  min-width: 0;
  border: none;
  margin: 11px 20px 10px;
  width: 100%;
  padding: 0px;

  
  &:disabled {
    background-color: #fff;
    color: black;
    font-weight: 400;
  }

  @media only screen and (max-width: ${theme.breakpoints.M}) {
    ::placeholder, ::-webkit-input-placeholder  {
      font-size: 15px;
    }
  }
`);

export const PrefixContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  border-right: 1px solid #6b6b6b;
  margin-top: 11px;
  margin-bottom: 11px;
`;